<template>
<v-card>
    <v-card-title>
        {{ trans('user_detail.title') }}
    </v-card-title>
    <v-card-subtitle style="background-color: #F4F6F6;">
        {{ trans('user_detail.sub_title')}}
    </v-card-subtitle>
            <v-card-text>
                <template v-slot:extension>
                    <v-tabs
                        v-model="tab"
                        align-with-title
                    ></v-tabs>

                </template>
                <v-row>
                    <v-col cols="12" md="12" class="my-5">
                        <v-card
                            class="mx-auto"
                            outlined
                            >
                            <v-card-text>
                                <v-row>
                                    <v-col cols="3" md="3" style="border-right: 1px solid lightgray; text-align: center;">
                                        <v-list-item three-line>
                                            <v-list-item-content>
                                                <v-list-item-avatar size="200">

                                                    <v-img v-if="data.avatar" :src="data.avatar" style="border-radius: 50%;" max-width="200px" />
                                                    <v-icon v-else x-large style="border-radius: 50%; background-color: lightgray;">person</v-icon>
                                                </v-list-item-avatar>
                                                <v-list-item-title>
                                                    <h2> {{ data.name }}</h2>
                                                </v-list-item-title>
                                                <v-list-item-subtitle>
                                                    {{ data.qualification }}
                                                </v-list-item-subtitle>
                                                <br><br>
                                                <v-list-item-subtitle>
                                                    {{ data.email }}
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle>
                                                    {{ data.user_info.tel }}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="9" md="9">

                                        <v-tabs
                                            v-model="tab"
                                            centered
                                            icons-and-text


                                        >
                                        <v-tabs-slider></v-tabs-slider>

                                            <v-tab href="#summary">
                                                {{ trans('user_detail.summary') }}
                                                <v-icon>grid_view</v-icon>
                                            </v-tab>

                                            <v-tab href="#calendar">
                                                {{ trans('user_detail.calendar') }}
                                                <v-icon>calendar_month</v-icon>
                                            </v-tab>

                                            <v-tab href="#targets">
                                                {{ trans('user_detail.targets') }}
                                                <v-icon>checklist</v-icon>
                                            </v-tab>


                                            <v-tabs-items v-model="tab">

                                                <v-tab-item
                                                    value="summary"
                                                >
                                                    <user-summary
                                                    :user="user"
                                                    :user_targets_not_ended="user_targets_not_ended"
                                                    :user_targets_to_completed="user_targets_to_completed"
                                                    :user_targets_completed="user_targets_completed"
                                                    :user_target_action="user_target_action"
                                                    >
                                                    </user-summary>
                                                </v-tab-item>

                                                <v-tab-item
                                                    value="targets"
                                                >

                                                    <user-targets
                                                    :user_targets="user_targets"
                                                    :user_target_action="user_target_action"
                                                    >
                                                    </user-targets>


                                                </v-tab-item>
                                                <v-tab-item
                                                    value="calendar"
                                                >
                                                <target-calendar :target_calendar_action="target_user_calendar_action"></target-calendar>
                                                </v-tab-item>
                                            </v-tabs-items>
                                        </v-tabs>




                                </v-col>
                            </v-row>

                            </v-card-text>


                            </v-card>
                        </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" md="12">
                        <br>
                    </v-col>
                </v-row>


            </v-card-text>
            <v-card-actions>

                <a href="#">
                        <v-btn color="grey" onclick="history.back()">
                            <v-icon right>arrow_back</v-icon>&nbsp;{{ trans('common.null_op') }}
                        </v-btn>
                    </a>
            </v-card-actions>

        </v-card>
  </template>
<script>

import UserSummary from './UserSummary.vue';
import UserTargets from './UserTargets.vue';
import TargetCalendar from '../Target/TargetCalendar.vue';


export default {

    name: "user-detail",

    props: {
        user: { type: Object , default:{} },
        user_targets: { type: Array, default: [] },
        target_user_calendar_action: { default: '' },
        user_target_action: { default: ''}

    },
    data() {


        let data = this.user;

        let user_targets_not_ended = [];
        let user_targets_to_completed = [];
        let user_targets_completed = [];

        for(let user_target of this.user_targets) {

            // alert(JSON.stringify(user_target));

            if(user_target.user_target_ended == null) {

                user_targets_not_ended.push(user_target);

            } else if(user_target.user_target_completed == null) {

                user_targets_to_completed.push(user_target);

            } else {

                user_targets_completed.push(user_target);

            }
        }
        return {
            data,
            user_targets_not_ended,
            user_targets_to_completed,
            user_targets_completed,
            tab: null
        }
    },

    mounted() {
    },
    methods: {

        roundedHours(second_hours) {
                    let fl_hours = second_hours / 3600;
                    return Math.round(fl_hours * 100) / 100
                },

        perc(max, current) {
            let kx = 100.0 / parseFloat(max);
            let y = parseFloat(current) * kx;
            return Math.round(y * 100.0) / 100.0;

        },

        percCustomColor(max, min) {

                let perc = this.perc(max, min);

                    // default green
                    let color = '#4CAF50'; // 100%
                    let background_color = '#A5D6A7';

                    if(perc < 25.0) {
                        // red
                        color = '#F44336';
                        background_color = '#EF9A9A';

                    } else if(perc <= 50.0) {
                        // orange
                        color = '#FFB74D'; // orange lighten-2
                        background_color = '#FFE0B2'; // orange lighten-4


                    } else if(perc < 75.0) {
                        // orange
                        color = '#FF9800';
                        background_color = '#FFE0B2';


                    } else if(perc > 105) {

                        background_color = '#EF9A9A';

                        if(perc < 110) {
                            // lime darken-4
                            color = '#827717';

                        } else if(perc < 125) {
                            // deep-orange darken-4
                            color = '#BF360C';

                        } else if(perc < 150) {
                            // red accent-4
                            color = '#D50000';

                        } else if(perc < 175) {
                            // pink accent-4
                            color = '#C51162';

                        } else if(perc > 175) {
                            // purple accent-4
                            color = '#AA00FF';
                        }

                    }

                    return color;
        },


    },

    computed: {


    },

    components: {
        UserSummary,
        TargetCalendar,
        UserTargets
    }


}

</script>
